/**
 * Implement this interface for clock.
 */
export interface Clock {
   currentDate(): Date;
}

/**
 * ConstantClock is used to retrieve constant clock.
 */
export class ConstantClock implements Clock {
   date: Date;

   constructor(date: Date) {
      this.date = date;
   }

   currentDate(): Date {
      return this.date;
   }
}

/**
 * RealClock is used to retrieve realtime clock.
 */
export class RealClock implements Clock {
   currentDate(): Date {
      return new Date(Date.now());
   }
}

let defaultClock = new RealClock();

/**
 * Sets default clock.
 *
 * @param {Clock} clock
 */
export const setDefaultClock = (clock: Clock) => {
   defaultClock = clock;
};

/**
 * To get current date.
 *
 * @return {Date} current date
 */
export const currentDate = () => {
   return defaultClock.currentDate();
};
